import { render, staticRenderFns, recyclableRender, components } from "./agreement-description.vue?vue&type=template&id=3994ee7a&scoped=true&"
var renderjs
import script from "./agreement-description.vue?vue&type=script&lang=js&"
export * from "./agreement-description.vue?vue&type=script&lang=js&"
import style0 from "./agreement-description.vue?vue&type=style&index=0&id=3994ee7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994ee7a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/agreement-description/agreement-description.vue"
export default component.exports